export default [
  {
    to: '/services',
    children: 'Services',
    desktop: true,
  },
  {
    to: '/about',
    children: 'About',
    desktop: true,
  },
  {
    to: '/gallery',
    children: 'Project Gallery',
    desktop: true,
  },
  {
    to: '/quote',
    children: 'Request Quote',
    footer: true,
  },
  {
    to: '/careers',
    children: 'Careers',
    desktop: true,
  },
  {
    to: '/contact',
    children: 'Contact Us',
    footer: true,
  },
];



// WEBPACK FOOTER //
// ./src/config/links.js